import data from "@/assets/data/PlayerData.js";

import Mutations from "@/store/modules/playerData/mutations.js";
import Getters from "@/store/modules/playerData/getters.js";

export default {
  state() {
    return {
      selectedGamer: 0,
      allplayerData: data.playerData,
      selectedplayerData: [],
      gamerRate: 1.2,
      mySalary:0,
    };
  },
  mutations: Mutations,
  getters: Getters,
};
